module.exports = __webpack_public_path__ + "643b2855b5dda7eb591f48f0864641eb.png";